// CompanyModal — opens from the user avatar. Tabs for members
// + invitations (this pass). Future: sections-access, general settings.
// Mirrors AgentModal style: scrim + ref-contains-check close.

import { useEffect, useRef } from "react"
import { useStore } from "../../stores/store"
import {
  companyModalStore,
  closeCompanyModal,
  setCompanyModalTab,
  loadCompanyData,
} from "../../stores/companyModalStore"
import { useBootstrap, useTranslations } from "../../lib/translations"
import { MembersTab } from "./MembersTab"
import { InvitationsTab } from "./InvitationsTab"

const TABS = ["members", "invitations"]

export function CompanyModal() {
  const t = useTranslations()
  const bootstrap = useBootstrap()
  const open = useStore(companyModalStore, (s) => s.open)
  const tab  = useStore(companyModalStore, (s) => s.tab)
  const modalRef = useRef(null)

  useEffect(() => {
    if (!open) return
    loadCompanyData(bootstrap.paths)
    const onKey = (e) => { if (e.key === "Escape") closeCompanyModal() }
    window.addEventListener("keydown", onKey)
    return () => window.removeEventListener("keydown", onKey)
  }, [open, bootstrap.paths])

  if (!open) return null

  const onScrim = (e) => {
    if (modalRef.current && !modalRef.current.contains(e.target)) closeCompanyModal()
  }

  const company = bootstrap.current_company

  return (
    <div className="cm-scrim" onMouseDown={onScrim}>
      <div className="cm-modal" ref={modalRef}>
        <div className="cm-mside">
          <div>
            <h3>{company?.name}</h3>
            <div className="sub">{t("company_modal.subtitle")}</div>
          </div>
        </div>
        <div className="cm-mmain">
          <div className="cm-tabhead">
            <div className="cm-tabs">
              {TABS.map((k) => (
                <button key={k} type="button"
                        className={`cm-tab ${tab === k ? "on" : ""}`}
                        onClick={() => setCompanyModalTab(k)}>
                  {t(`company_modal.tabs.${k}`)}
                </button>
              ))}
            </div>
            <div className="cm-x" onClick={closeCompanyModal} title={t("modal.close")}>✕</div>
          </div>
          {tab === "members"     && <MembersTab />}
          {tab === "invitations" && <InvitationsTab />}
        </div>
      </div>
    </div>
  )
}
